// ML AccessRights 13/08/2024
// src/utils/permissions.js
export function can(checkType, form, control = null) {
  const claims = JSON.parse(localStorage.getItem('claims') || '[]');
  const target = `${checkType}:${form}:${control || '*'}`;
  return claims.includes(target);
}

export function canForm(form) {
  return can('F', form);
}

export function canControl(form, control) {
  return can('C', form, control);
}
